<template lang="html">
  <nav @click="$root.$emit('goToAbout'); $root.$emit('resetAbout');" :class="{ 'opacity-0': hide }" class="select-none fixed top-0 left-0 p-5 z-50 cursor-pointer link">
    Omnigroup
  </nav>
</template>

<script>
  export default {
    data() {
      return {
        hide: false,
      }
    },
    mounted() {
      this.$root.$on('toggleomni', (state) => {
        this.hide = state
      })
    }
  }
</script>